// removed by extract-text-webpack-plugin
module.exports = {"Menu":"Payment__Menu___2fpjE","Additional":"Payment__Additional___LjbCg","Title":"Payment__Title___21gV1","Checkboxes":"Payment__Checkboxes___iQ_3O","Button":"Payment__Button___3p644","FirstColumn":"Payment__FirstColumn___3vDSX","SecondColumn":"Payment__SecondColumn___VRF_k","Checkbox":"Payment__Checkbox___369pn","ButtonWrap":"Payment__ButtonWrap___cZDDW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/Payment/Payment.scss
// module id = 1401
// module chunks = 0